/* global window */

(() => {
  const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const HISTORY_KEY = 'serviceRepairReceipt';

  class ServiceRepairReceiptStore {
    constructor(pathname = window.location.pathname) {
      this.pathname = pathname;
      this.key = `service-repair:receipt:${pathname}`;
    }

    get() {
      let storedReceipt = '';
      try {
        storedReceipt = window.sessionStorage.getItem(this.key) || '';
      } catch {
        // Use the history entry when session storage is unavailable.
      }

      const historyReceipt = this.getHistoryReceipt();
      const receipt = [historyReceipt, storedReceipt].find((value) => UUID_PATTERN.test(value)) || '';
      if (receipt) {
        if (receipt !== storedReceipt) this.saveToSessionStorage(receipt);
        return receipt;
      }

      this.clear();
      return '';
    }

    save(receipt) {
      const normalizedReceipt = String(receipt || '');
      if (!UUID_PATTERN.test(normalizedReceipt)) return false;

      const storedInSession = this.saveToSessionStorage(normalizedReceipt);
      const storedInHistory = this.saveToHistory(normalizedReceipt);

      return storedInSession || storedInHistory;
    }

    saveToSessionStorage(receipt) {
      try {
        window.sessionStorage.setItem(this.key, receipt);
        return true;
      } catch {
        return false;
      }
    }

    getHistoryReceipt() {
      const entry = window.history?.state?.[HISTORY_KEY];
      if (!entry || entry.pathname !== this.pathname) return '';

      return String(entry.receipt || '');
    }

    saveToHistory(receipt) {
      if (!window.history || typeof window.history.replaceState !== 'function') return false;

      try {
        const currentState = this.getHistoryState();
        window.history.replaceState(
          {
            ...currentState,
            [HISTORY_KEY]: { pathname: this.pathname, receipt },
          },
          '',
          window.location.href,
        );
        return true;
      } catch {
        return false;
      }
    }

    getHistoryState() {
      const state = window.history?.state;

      return state && typeof state === 'object' && !Array.isArray(state) ? state : {};
    }

    clear() {
      try {
        window.sessionStorage.removeItem(this.key);
      } catch {
        // Storage may be unavailable in privacy modes.
      }

      if (!window.history || typeof window.history.replaceState !== 'function') return;

      try {
        const currentState = this.getHistoryState();
        if (currentState[HISTORY_KEY]?.pathname !== this.pathname) return;

        const nextState = { ...currentState };
        delete nextState[HISTORY_KEY];
        window.history.replaceState(nextState, '', window.location.href);
      } catch {
        // History state may be unavailable in embedded or restricted contexts.
      }
    }
  }

  window.ServiceRepairReceiptStore = ServiceRepairReceiptStore;
})();
